export default "__VITE_ASSET__y2rUsk58__"